import { Column } from "@components/Layout";
import { styled } from "solid-styled-components";

export const TracklistDrawerWrapper = styled(Column)`
    border-radius: 35px 35px 0 0 ;
    background: ${({ theme }) => theme?.tracklist.list};
    @media only screen and (min-width: 513px) {
        display: none;
    }

`;
export const Pill = styled.div`
    width: 50px;
    height: 6px;
    border-radius: 3px;
    background: ${({ theme }) => theme?.colors.accentTertiary};
    margin: 0 auto;
`;
